import React from 'react';
import PropTypes from 'prop-types';

import { Transition } from 'react-transition-group';
import { FadeContainer } from './style';

/** Fade transition. */
const Fade = React.forwardRef((props, ref) => {
  const {
    in: inProp,
    children,
    timeout,
    absolute,
    unmountOnExit,
    className,
    ...otherProps
  } = props;

  return (
    <Transition
      appear
      in={inProp}
      timeout={{ enter: 0, exit: timeout }}
      unmountOnExit={unmountOnExit}
      {...otherProps}
    >
      {(state) => (
        <FadeContainer
          ref={ref}
          state={state}
          timeout={timeout}
          absolute={absolute}
          className={className}
        >
          {children}
        </FadeContainer>
      )}
    </Transition>
  );
});

Fade.displayName = 'Fade';

Fade.defaultProps = {
  in: false,
  timeout: 1000,
  absolute: false,
  unmountOnExit: true,
  className: null,
};

Fade.propTypes = {
  in: PropTypes.bool,
  timeout: PropTypes.number,
  children: PropTypes.node.isRequired,
  absolute: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  className: PropTypes.string,
};

export default Fade;
